export const cleanStatus = (status) => {
  if (!status) return '';
  return String(status).replace(/\s*\(.*?\)/g, '').trim();
};
